import 'reflect-metadata';
import '@dsk-digital/platform/http/setup.ts';
import { createRoot } from 'react-dom/client';
import { StrictMode, Suspense } from 'react';
import { App } from './app.tsx';
import './styles/global.scss';
import './styles/colors.css';
import { FeatureFlagsProvider } from '@dsk-digital/platform/feature-flags/feature-flags-provider.tsx';

createRoot(document.getElementById('root')).render(
	<StrictMode>
		<FeatureFlagsProvider>
			<Suspense>
				<App />
			</Suspense>
		</FeatureFlagsProvider>
	</StrictMode>,
);
